// const backrests = ['seat_1', 'seat_2', 'seat_3', 'seat_5', 'seat_6', 'seat_8', 'seat_9'].map((node) => ({
const backrests = ['seat_5', 'seat_8'].map((node) => ({
  node,
  buttonImage: require(`../img/${node}.png`),
  buttonName: node.split('_')[1],
}))

export default backrests
